"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// ==========================================================================
// Breakpoints
// https://github.com/twbs/bootstrap/blob/v4-dev/scss/_variables.scss#L205-L211
// ==========================================================================
var xs = 0;
var sm = 576;
var md = 768;
var lg = 992;
var xl = 1200;
var breakpoint = {
  xs: {
    min: "".concat(xs, "px"),
    max: "".concat(sm - 1, "px")
  },
  sm: {
    min: "".concat(sm, "px"),
    max: "".concat(md - 1, "px")
  },
  md: {
    min: "".concat(md, "px"),
    max: "".concat(lg - 1, "px")
  },
  lg: {
    min: "".concat(lg, "px"),
    max: "".concat(xl - 1, "px")
  },
  xl: {
    min: "".concat(xl, "px"),
    max: "".concat(xl, "px")
  }
};
var _default = exports.default = breakpoint;